import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, MenuBuilder, openContent, SimpleListAdapter, Button } from '@nu-art/thunderstorm-frontend/index';
import './PgDev_PopUpTest.scss';
const menuOptions = ['Option 1', 'Option 2', 'Option 3'];
class PgDev_PopUpTest_Class extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        return;
    }
    getMousePos = (e) => {
        return { x: e.clientX, y: e.clientY };
    };
    openMenuPopUp = (e) => {
        const adapter = SimpleListAdapter(menuOptions, item => _jsx("div", { children: item.item }));
        const id = 'pg-dev__menu-pop-up';
        const pos = this.getMousePos(e);
        new MenuBuilder(adapter, pos, { x: 0, y: 1 })
            .setId(id)
            .show();
    };
    render() {
        return _jsxs("div", { id: 'pg-dev__pop-up-test', children: [_jsx(Button, { onClick: this.openMenuPopUp, children: "Open Menu Pop Up" }), _jsx("div", { ...openContent.popUp.bottom('pg-dev__custom-pop-up', () => _jsx("div", { children: "This is a pop up with custom content!" }), 10), children: "Open Custom Pop Up" })] });
    }
}
export const PgDev_PopUpTest = {
    name: 'Pop Up Test',
    key: 'pop-up-test',
    renderer: PgDev_PopUpTest_Class
};
